









import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    "brand-store-settings": () =>
      import(
        "@/components/app/admin/settings/brands/ecommerce/brandStoreSettings.vue"
      )
  }
})
export default class AdminBrandStoreSettings extends Vue {}
